/* NIVIÈREE · barra de coleções do Explore (home)
 *
 * 29-10-2026: a barra voltou ao design da primeira barra de coleções do header —
 * transparente, por cima do topo das fotos, com uma linha fininha de rolagem (1px)
 * mostrando que dá para deslizar quando os nomes não cabem na tela (celular).
 * A setinha "›" com degradê branco ficou escondida nesse design (ver a seção).
 * Continua a espiadinha: na primeira vez que a barra aparece na tela (uma vez por
 * visita), ela desliza até a última coleção e volta.
 */
(() => {
  if (window.__nvrExploreNav) return;
  window.__nvrExploreNav = true;

  const NUDGE_KEY = 'nvr-explore-nav-nudged';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const nudgedAlready = () => {
    try { return sessionStorage.getItem(NUDGE_KEY) === '1'; } catch (_e) { return false; }
  };
  const markNudged = () => {
    try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (_e) { /* sem armazenamento */ }
  };

  const setup = (nav) => {
    if (nav.dataset.nvrNavReady) return;
    nav.dataset.nvrNavReady = 'true';

    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'nvr-explore-more';
    more.setAttribute('aria-label', 'Ver mais coleções');
    more.innerHTML = '<svg viewBox="0 0 8 14" aria-hidden="true" focusable="false"><path d="M1 1l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
    nav.appendChild(more);

    // Linha fininha de rolagem (trilho + indicador), igual à da primeira barra do header.
    const scrollbar = document.createElement('div');
    scrollbar.className = 'nvr-explore-scroll';
    scrollbar.setAttribute('aria-hidden', 'true');
    scrollbar.hidden = true;
    scrollbar.innerHTML = '<span class="nvr-explore-scroll__thumb"></span>';
    nav.insertAdjacentElement('afterend', scrollbar);
    const thumb = scrollbar.firstElementChild;

    const maxScroll = () => Math.max(0, nav.scrollWidth - nav.clientWidth);

    const updateScrollbar = (max) => {
      scrollbar.hidden = max <= 4;
      if (scrollbar.hidden) return;
      scrollbar.style.top = (nav.offsetTop + nav.offsetHeight - 1) + 'px';
      const trackWidth = scrollbar.clientWidth;
      const ratio = nav.scrollWidth > 0 ? Math.min(1, nav.clientWidth / nav.scrollWidth) : 1;
      const thumbWidth = Math.max(Math.min(trackWidth, 28), trackWidth * ratio);
      const progress = max > 0 ? Math.min(1, Math.max(0, nav.scrollLeft / max)) : 0;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translate3d(' + ((trackWidth - thumbWidth) * progress) + 'px, 0, 0)';
    };

    const update = () => {
      const max = maxScroll();
      nav.classList.toggle('nvr-overflows', max > 4);
      nav.classList.toggle('nvr-has-more', max > 4 && nav.scrollLeft < max - 4);
      updateScrollbar(max);
    };

    more.addEventListener('click', () => {
      nav.scrollTo({ left: maxScroll(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });

    nav.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(nav);
      if (nav.parentElement) resizeObserver.observe(nav.parentElement);
    }
    update();

    // Espiadinha: uma vez por visita, quando a barra entra na tela.
    if (reduceMotion.matches || nudgedAlready() || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry || entry.intersectionRatio < 0.9) return;
      observer.disconnect();
      if (maxScroll() <= 4 || nav.scrollLeft > 4) return;
      markNudged();
      window.setTimeout(() => {
        nav.scrollTo({ left: maxScroll(), behavior: 'smooth' });
        window.setTimeout(() => nav.scrollTo({ left: 0, behavior: 'smooth' }), 1100);
      }, 350);
    }, { threshold: [0.9] });
    observer.observe(nav);
  };

  const init = () => {
    document.querySelectorAll('.nivieree-explore__collection-nav').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  // O editor de tema recarrega seções sem recarregar a página.
  document.addEventListener('shopify:section:load', init);
})();
